// extracted by mini-css-extract-plugin
module.exports = {"link":"e462cbfa4b--link--OMKb3"};